import React from "react";
import CommonTimeLineItem from "./CommonTimeLineItem";
import TopTimeLineItem from "./TopTimeLineItem";
import CardPost from "./CardPost";

const TimelineCard = ({ postInfo, position, length }) => {
  if (position === 0)
    return (
      <TopTimeLineItem>
        <CardPost {...postInfo} />
      </TopTimeLineItem>
    );
  else if (length - 1 !== position)
    return (
      <CommonTimeLineItem>
        <CardPost {...postInfo} />
      </CommonTimeLineItem>
    );
  else
    return (
      <CommonTimeLineItem last>
        <CardPost {...postInfo} />
      </CommonTimeLineItem>
    );
};

export default TimelineCard;
